import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { blockConfig } from '../../../config';

const BlockInfoWrapper = styled.div`
  padding: ${blockConfig.padding}px;
  height: 100%;
  font-size: 14px;
  letter-spacing: 1px;
  line-height: 16px;
  overflow: hidden;
  ${p => p.loadingIconBefore && `
    display: inline-block;
  `}
`;

const Line = styled.div`
  font-weight: ${p => p.bold ? '600' : 0};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${p =>
    !p.bold &&
    css`
      color: #64747c;
    `}
`;

const BlockInfo = ({ prefix = null, line1, line2, line3 }) =>
  <>
    {prefix}
    <BlockInfoWrapper loadingIconBefore={!!prefix}>
      {line1 && <Line data-test-id='planning-block-line1' bold={true}>{line1}</Line>}
      {line2 && <Line data-test-id='planning-block-line2' bold={true}>{line2}</Line>}
      {line3 && <Line data-test-id='planning-block-line3' bold={false}>{line3}</Line>}
    </BlockInfoWrapper>
  </>;

BlockInfo.propTypes = {
  prefix: PropTypes.element,
  line1: PropTypes.string,
  line2: PropTypes.string,
  line3: PropTypes.string,
};

export default React.memo(BlockInfo);
